import React from 'react';
import './SettingsModal.css';

import { Text, Select, Button, Checkbox } from "@geist-ui/core";
import {
  Mic,
  Volume2,
  Plus,
  Minus,
  StopCircle,
  PlayCircle,
  FastForward,
} from "@geist-ui/icons";
import { trackSettingChange } from '../../../config/analytics';
import { VOICE_NAME_MAPPING } from '../../../constants';

const SettingsModal = ({
  isOpen,
  onClose,
  volume,
  onVolumeChange,
  isPlaying,
  handlePlayPause,
  handleStop,
  currentTime,
  duration,
  handleSeek,
  isAutoplay,
  toggleAutoplay,
  isBackgroundMusicPlaying,
  toggleBackgroundMusic,
  backgroundMusicVolume,
  handleBackgroundMusicVolumeChange,
  fontSize,
  handleFontSizeChange,
  voicePreference,
  handleVoiceChange,
  handleColumns,
  isTwoColumns,
  playbackRate,
  handlePlaybackRateChange
}) => {
  if (!isOpen) return null;

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };

  const handleFontSizeChangeWrapper = (increment) => {
    const newSize = fontSize + increment;
    trackSettingChange('Font Size', newSize);
    handleFontSizeChange(increment);
  };

  const handleColumnsWrapper = () => {
    trackSettingChange('Columns', isTwoColumns ? 'Single' : 'Double');
    handleColumns(!isTwoColumns);
  };

  const handlePlaybackRateChangeWrapper = (rate) => {
    trackSettingChange('Playback Rate', rate);
    handlePlaybackRateChange(rate);
  };

  return (
    <div className="settings-modal-overlay">
      <div className="settings-modal">
        <Text h2>Story Settings</Text>

        <div className="settings-section">
          <Text h3>Voice Preference</Text>

          <div className="voice-control">
            <Mic />

            <Select value={voicePreference} placeholder={voicePreference} onChange={val => handleVoiceChange(val)}>
          
              <Select.Option value="Johan">Johan</Select.Option>
              <Select.Option value="Lisbeth">Lisbeth</Select.Option>
            </Select>
          </div>
        </div>

        <div className="settings-section">
          <Text h3>Audio Player</Text>

          <div className="volume-control">
            <Volume2 />

            <input
              type="range"
              min="0"
              max="1"
              step="0.01"
              value={volume}
              onChange={(e) => onVolumeChange(e)}
              className="volume-slider"
            />
          </div>
          <div className="autoplay-control">
              <Checkbox value={isAutoplay} checked={isAutoplay} onChange={val => toggleAutoplay(val)}>Autoplay</Checkbox>            
          </div>
        </div>

        <div className="settings-section">
          <Text h3>Playback Speed</Text>
          
          <div className="playback-rate-controls">
            <FastForward />
            <div className="speed-buttons">
              <Button 
                onClick={() => handlePlaybackRateChangeWrapper(0.75)} 
                className={`speed-button ${playbackRate === 0.75 ? 'active' : ''}`}
                auto
              >
                0.75x
              </Button>
              <Button 
                onClick={() => handlePlaybackRateChangeWrapper(1.0)} 
                className={`speed-button ${playbackRate === 1.0 ? 'active' : ''}`}
                auto
              >
                1x
              </Button>
              <Button 
                onClick={() => handlePlaybackRateChangeWrapper(1.25)} 
                className={`speed-button ${playbackRate === 1.25 ? 'active' : ''}`}
                auto
              >
                1.25x
              </Button>
              <Button 
                onClick={() => handlePlaybackRateChangeWrapper(1.5)} 
                className={`speed-button ${playbackRate === 1.5 ? 'active' : ''}`}
                auto
              >
                1.5x
              </Button>
            </div>
          </div>
        </div>

        <div className="settings-section">
          <Text h3>Font Size</Text>
          
          <div className="font-size-controls">
            <Button icon={<Minus />} onClick={() => handleFontSizeChangeWrapper(-1)} auto>A</Button>
   
            <span className="current-font-size">{fontSize}px</span>
           
            <Button icon={<Plus />} onClick={() => handleFontSizeChangeWrapper(1)} auto>A</Button>
          </div>
        </div>

        <div className="settings-section">
          <Text h3>Two columns grid</Text>

          <div>
              <Checkbox value={isTwoColumns} checked={isTwoColumns} onChange={val => handleColumnsWrapper(val)}>{isTwoColumns ? 'Enabled' : 'Enable'}</Checkbox>            
          </div>
        </div>
        <small style={{ fontSize: '0.75rem', color: '#888', display: 'block'}}>
          Obvious Mimic solo adventures include material taken from the System Reference Document 5.1 ("SRD 5.1") by Wizards of the Coast LLC and available{' '}
          <a href="https://dnd.wizards.com/resources/systems-reference-document" target="_blank" rel="noopener noreferrer">here</a>. The SRD 5.1 is licensed under the Creative Commons Attribution 4.0 International License available{' '}
          <a href="https://creativecommons.org/licenses/by/4.0/legalcode" target="_blank" rel="noopener noreferrer">here</a>.
        </small>
        <Button onClick={onClose} className="theme-button theme-button--w100">
          <Text span>Close</Text>
        </Button>
      </div>
    </div>
  );
};

export default SettingsModal;